import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ActionButtonLink } from 'App/components/styles/ActionCell';
import ViewAttachments from 'App/components/ViewAttachments';
import useFetchPatientActivityFiles from 'App/hooks/useFetchPatientActivityFiles';

const propTypes = {
    patientId: PropTypes.string.isRequired,
};

const defaultProps = {};

function PatientAttachments({ patientId }) {
    const { data: attachments } = useFetchPatientActivityFiles(patientId);
    const [showAttachmentModal, setShowAttachmentModal] = useState(false);

    return (
        <>
            <ActionButtonLink onClick={() => setShowAttachmentModal(true)}>
                View Attachments <span id="number-of-uploads">({attachments?.numberOfUploads || 0})</span>
            </ActionButtonLink>
            <ViewAttachments
                attachments={attachments}
                show={showAttachmentModal}
                onHide={() => setShowAttachmentModal(false)}
                patientId={patientId}
            />
        </>
    );
}

PatientAttachments.propTypes = propTypes;
PatientAttachments.defaultProps = defaultProps;

export default PatientAttachments;
